import React, {Component} from 'react';
import logo_qw from "../../cloud/image/stepByStep/logo_qw.png";
import title_qw from "../../cloud/image/stepByStep/title_qw.png";
import img_01 from "../../cloud/image/stepByStep/01.png";
import img_02 from "../../cloud/image/stepByStep/02.png";
import img_03 from "../../cloud/image/stepByStep/03.png";
import img_04 from "../../cloud/image/stepByStep/04.png";
import scan from "../../cloud/image/stepByStep/scan.png";
import qrcode from "../../../images/scanstep/scan_step_qrcode.png";

class QwStep extends Component {
    render() {
        return (
            <div className={'cloud-step-max'} style={{height: 'calc(100vh - 140px)'}}>
                <div className={'cloud-step-content'}>
                    <div className={'cloud-step-left'}>
                        <img src={logo_qw} className={'logo_pro'}/>
                        <img src={title_qw} className={'title_pro'}/>
                        <ul className={'step-list'}>
                            <li>
                                <img src={img_01}/>
                                客户裂变，通过奖品激励用户邀请好友加企业微信，实现客户指数级增长
                            </li>
                            <li>
                                <img src={img_02}/>
                                群裂变，通过奖励激励客户邀请好友进群，快速实现社群增长
                            </li>
                            <li>
                                <img src={img_03}/>
                                抽奖裂变，客户通过邀请好友加企业微信增加抽奖机会，边玩便增长
                            </li>
                            <li>
                                <img src={img_04}/>
                                红包获客，客户邀请好友加企业微信领取红包，邀请的越多，红包越多
                            </li>
                        </ul>
                    </div>
                    <div className={'cloud-step-right'}>
                        <div className={'title-s1'}>扫码添加客服微信</div>
                        <div className={'title-s1'}>联系客户开通产品试用</div>
                        <div className={'step-qr-code-max'}>
                            <img src={qrcode}/>
                        </div>
                        <div className={'scan-desc'}>
                            <img src={scan}/>
                            <span>请扫码联系客服开通</span>
                        </div>
                        <div className={'title-s2'}>新用户可免费试用</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default QwStep;